/**
 * Resolve which logo to render for a carrier.
 *
 * Partners can override our logos entirely through the theme, without any
 * backend change, by passing:
 *
 *   theme: {
 *     logos: {
 *       hide: false,
 *       urlTemplate: 'https://partner.com/logos/{iata}.png',
 *       overrides: { FR: 'https://partner.com/logos/ryanair-alt.png' },
 *     },
 *   }
 *
 * Resolution order is: hide wins outright, then a per-carrier override, then
 * the URL template, then the logo the server gave us.
 *
 * `{iata}` interpolates the carrier code as it appears on the flight (upper
 * case, e.g. `FR`); `{iata_lower}` is offered for partners whose assets are
 * named in lower case, matching our own `cq_logo.png` convention.
 *
 * Returns null only when the partner has hidden logos, which is the one case
 * where the <img> should not be rendered at all. When there is simply no logo
 * available the server value is passed through untouched (it may be an empty
 * string), so the element still reserves its space exactly as it did before.
 */
export const resolveAirlineLogo = (theme, iataCode, serverLogo) => {
  const logos = theme?.logos;

  if (logos?.hide) return null;

  const iata = typeof iataCode === 'string' ? iataCode.trim() : '';

  if (iata && logos?.overrides) {
    const override =
      logos.overrides[iata] ?? logos.overrides[iata.toUpperCase()];
    if (override) return override;
  }

  if (iata && logos?.urlTemplate) {
    return logos.urlTemplate
      .replace(/\{iata\}/g, iata)
      .replace(/\{iata_lower\}/g, iata.toLowerCase());
  }

  return serverLogo;
};

export default resolveAirlineLogo;
